import EventEmitter from "eventemitter3";

export const COLORIZE = "EVT_COLORIZE";

export default new EventEmitter();
